<template>
  <div class="stock checkbox-label-equipment">
    <div class="input-group">
      <EquipmentSelector
        class="mr-auto"
        :value="value"
        :group="group"
        :trim-equipment-route="trimEquipmentRoute"
        @change="updateEquipment($event)"
      />
      <EquipmentImportantSwitch :value="value" :group="group" @change="updateEquipment($event)" />
    </div>
  </div>
</template>

<script>
import EquipmentSelector from '@components/equipment/EquipmentSelector.vue'
import EquipmentImportantSwitch from '@components/equipment/EquipmentImportantSwitch.vue'

export default {
  name: 'EquipmentItem',
  components: { EquipmentSelector, EquipmentImportantSwitch },
  props: {
    group: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default() {
        return {
          isSelected: false,
          isDisabled: false,
          isSelectedInTrim: false
        }
      }
    },
    trimEquipmentRoute: {
      type: String,
      default: '#'
    }
  },
  methods: {
    updateEquipment(equipment) {
      this.$store.dispatch('stockEquipment/update', {
        group: this.group,
        equipment: equipment
      })
    }
  }
}
</script>
